<div class="NgxEditor__Seperator"></div>
<div class="NgxEditor__MenuItem NgxEditor__MenuItem--Text" (mousedown)="openRepository(repository)" [ngClass]="{'NgxEditor__MenuItem--Active': isActive, 'NgxEditor--Disabled': isDisabled}">
    <i class="fa-solid fa-image mt-2 ms-3" title="Insertar Imagen"></i>
</div>

<ng-template #repository let-c="close" let-d="dismiss">
    <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <app-repository-image (onSelected)="onSelectedImage($event)"></app-repository-image>
    </div>
</ng-template>